import Vue from 'vue'
import Vuex from 'vuex'
import api from '@/api'

Vue.use(Vuex)

const VIEWS = [ '3D', '2D' ]
const BASES = [
  'http://b.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
  'http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
  // 'https://maps.wikimedia.org/osm-intl/{z}/{x}/{y}.png',
  // 'https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}',
  'http://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png'
]

export default new Vuex.Store({
  state: {
    busList: [],
    view: 0,
    base: 0
  },
  mutations: {
    SET_BUS_LIST (state, busList) {
      state.busList = Object.freeze(busList)
    },
    TOGGLE_VIEW (state) {
      state.view = (state.view + 1) % 2
    },
    TOGGLE_BASE (state) {
      state.base = (state.base + 1) % 5
    }
  },
  actions: {
    async getBusList ({ commit }) {
      const { data } = await api.getBusList()
      commit('SET_BUS_LIST', data)
    },
    toggleView ({ commit }) {
      commit('TOGGLE_VIEW')
    },
    toggleBase ({ commit }) {
      commit('TOGGLE_BASE')
    }
  },
  getters: {
    busList: state => state.busList,
    view: state => VIEWS[state.view],
    base: state => BASES[state.base],
    is3D: (state, getters) => getters.view === '3D',
  },
  modules: {
  }
})
